import moment from "moment";
import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Input, Row } from "reactstrap";
import { getTaxReport } from "../services/waitlist-service";

const IncReports = () => {
  const [date, setDate] = useState();

  const handleDownload = (type, filename) => {
    getTaxReport(type,date).then(
      (res) => {
        var fileURL = window.URL.createObjectURL(res);
        var tempLink = document.createElement("a");
        tempLink.href = fileURL;
        tempLink.setAttribute("download", filename);
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
      },
      (err) => {
        console.log("Error fetching report:", err);
        toast.error("Error fetching report. Please try again.");
      }
    );
  };

  return (
    <>
      <Row className="reports-row">
        <div className="reports-container">
          <p className="title">
            <a href="/#/">
              <span style={{ color: "black" }} className="mdi mdi-arrow-left mr-3"></span>
            </a>
            Reports
          </p>

          <div className="cards-wrapper">
            <div className="cards">
              <div className="flex-column" style={{ minWidth: "max-content" }}>
                <p className="sub-title mb-2">Portfolio Holding Report</p>
                <Input
                  type="date"
                  name="date"
                  id="issueDate"
                  value={date && moment(date).format("YYYY-MM-DD")}
                  onChange={(e) => setDate(moment(e.target.value).format("MM/DD/YYYY"))}
                  max={moment().format("YYYY-MM-DD")}
                />
              </div>
              <div className="down-div">
                <p
                  className="download"
                  onClick={() => handleDownload("holdings", "PortfolioHoldingReport.xlsx")}
                >
                  Download
                </p>
              </div>
            </div>

            <div className="cards">
              <p className="sub-title">Transaction Report</p>
              <div className="down-div">
                <p
                  className="download"
                  onClick={() => handleDownload("transactions", "TransactionReport.xlsx")}
                >
                  Download
                </p>
              </div>
            </div>

            <div className="cards">
              <p className="sub-title">Tax Report</p>
              <div className="down-div">
                <p className="download" onClick={() => handleDownload("tax", "TaxReport.xlsx")}>
                  Download
                </p>
              </div>
            </div>
          </div>
        </div>
      </Row>
      <ToastContainer />
    </>
  );
};

export default IncReports;
